<script setup>
import {computed} from 'vue'
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"
import Button from "@/common/Button.vue"
import {useModalsStore} from '@/stores/modals'
import {useFormStore} from '@/stores/form'

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: String
})

// Pinia Stores
const modalsStore = useModalsStore()
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// --- Computed ---
const id = computed(() => formStore.value?.id)

// --- Methods ---
const openAddCreditModal = () => {
    modalsStore.show({
        componentName: 'OdpAddCreditModal',
        obj: {
            customerFormId: props.formId,
        }
    })
}

const openDeleteCreditModal = () => {
    modalsStore.show({
        componentName: 'OdpDeleteCreditModal',
        obj: {
            customerFormId: props.formId,
        }
    })
}

const openCreditHistoryModal = () => {
    modalsStore.show({
        componentName: 'OdpCreditHistoryModal',
        obj: {
            customerId: id.value,
        }
    })
}
</script>

<template>
    <div class="outer">
        <div class="d-flex align-items-center">
            <FormControlPlainText v-if="currentData.creditAmount" class="d-inline m-0" :form-id="formId">
                £{{ currentData.creditAmount }}
            </FormControlPlainText>

            <Button :disabled="!currentData.id" class="btn-sm ms-2" @click="openAddCreditModal">
                Add credit
            </Button>

            <Button :disabled="!currentData.id" class="btn-sm ms-2" @click="openDeleteCreditModal">
                Delete credit
            </Button>

            <Button class="btn-sm ms-2" @click="openCreditHistoryModal">
                View credit history
            </Button>
        </div>
    </div>
</template>

<style scoped>
.outer {
    display: flex;
    align-items: flex-start;
}
</style>